<template>
  <div class="page">
    <div class="layout">
      <el-row type="flex" align="middle" justify="space-between">
        <el-col :span="12">
          <div class="page-title">推廣</div>
        </el-col>
        <el-col :span="4" style="text-align: right;">
          <el-button type="info" @click.native="onAdd">新增推廣碼</el-button>
        </el-col>
      </el-row>
      <el-table :data="promotionCodes" style="width: 100%;">
        <el-table-column type="index" width="50" label="#"> </el-table-column>
        <el-table-column prop="code" label="推廣碼" align="left"> </el-table-column>
        <el-table-column prop="description" label="描述" align="left"> </el-table-column>
        <el-table-column prop="discount" label="折扣" align="left">
           <template slot-scope="{row}">
                <span>{{row.discount}}%</span>
           </template>
        </el-table-column>
        <el-table-column label="操作" width="100" align="center">
          <template slot-scope="{ row }">
            <el-button type="text" size="medium" @click="onDetailButton(row.id)"
              >詳情</el-button
            >
            <el-button type="text" size="medium" @click="onEditButton(row.id)"
              >編輯</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import {getPromotionCodes,addPromotionCodes,putPromotionCodes,getPromotionCodesDetail} from '@/api/order'
export default {
  data() {
    return {
      promotionCodes:[],
      isEdit: false,
      programmeId: null,
      formLabelAlign: {
        name: "",
        image: null,
      },
      centerDialogVisible: false,
      dialogSlotVisible: false,
      tableData: [],
      rules: {
        name: { required: true, message: "", trigger: "change" },
      },
    };
  },
  created() {
    this.getPromotionCodes();
  },
  methods: {
    onEditButton(id) {
      let path = `/promote/${id}/edit`;
      this.resolveRouter(path)
    },
    onDetailButton(id) {
      let path = `/promote/${id}`;
      this.resolveRouter(path)
    },
    onAdd() {
      let path = `/promote/add`;  
      this.resolveRouter(path)
    },
    onDialogConfirmFunction() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          if (this.isEdit) {
            this.putPromotionCodes();
          } else {
            this.addPromotionCodes();
          }
        } else {
          // console.log("error submit!!");
          return false;
        }
      });
    },
    childByValue(v) {
      this.formLabelAlign.image = v;
      this.addPromotionCodes();
    },
    onDialogCancelButton() {
      this.dialogSlotVisible = false;
    },
    onCancelButton() {
      this.centerDialogVisible = false;
    },
    onDeleteButton(id) {
      this.programmeId = id;
      this.centerDialogVisible = true;
    },
    getPromotionCodes(){
      getPromotionCodes().then((v)=>{
          this.promotionCodes = v.data
      })
    },
    addPromotionCodes() {
      addPromotionCodes(this.formLabelAlign)
        .then(() => {
          this.getPromotionCodes();
        })
        .finally(() => {
          this.dialogSlotVisible = false;
        });
    },
    getPromotionCodesDetail() {
      getPromotionCodesDetail(this.programmeId).then((v) => {
        this.formLabelAlign = v.data;
        this.dialogSlotVisible = true;
      });
    },
    putPromotionCodes() {
      putPromotionCodes(this.programmeId, this.formLabelAlign)
        .then(() => {
          this.getPromotionCodes();
        })
        .finally(() => {
          this.dialogSlotVisible = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.page {
  .layout {
    .el-row {
      margin-bottom: 20px;
      &:last-child {
        margin-bottom: 0;
      }

      .title {
        font-size: 30px;
      }
    }

    .item {
      color: #004eff;
      cursor: pointer;
      font-size: 20px;
    }
  }
}
</style>